import { PurchaseOrderItemStatus } from '../../constants/purchase-order-item-status.js';
import { PurchaseOrderStatus } from '../../constants/purchase-order-status.js';
import { QTY_SCALE } from '../../utils/quantity-scale.js';
function roundQty(value) {
    return Math.round(value * QTY_SCALE) / QTY_SCALE;
}
export function remainingOpenQty(qtyToFulfill, qtyFulfilled) {
    return Math.max(0, roundQty(qtyToFulfill - qtyFulfilled));
}
/** Compares two quantities at Decimal(28,9) precision instead of raw float equality. */
export function qtyEquals(qtyA, qtyB) {
    return roundQty(qtyA) === roundQty(qtyB);
}
/**
 * Advisory only — callers must enforce over-receipt inside a serializable transaction
 * or `SELECT … FOR UPDATE` on the PO line so concurrent receives cannot both pass
 * this check against a stale `qtyFulfilled`.
 */
export function isOverReceipt(qtyToFulfill, qtyFulfilled, qtyToReceive) {
    return qtyToReceive > remainingOpenQty(qtyToFulfill, qtyFulfilled);
}
export function purchaseOrderItemStatusAfterReceive(qtyToFulfill, qtyFulfilledAfter) {
    if (qtyToFulfill <= 0) {
        return PurchaseOrderItemStatus.PARTIAL;
    }
    // Rounded to the same Decimal(28,9) scale as remainingOpenQty/isOverReceipt — otherwise a
    // qty whose float conversion loses fidelity at the 10th+ decimal digit could land on the
    // wrong side of the >= boundary.
    return roundQty(qtyFulfilledAfter) >= roundQty(qtyToFulfill)
        ? PurchaseOrderItemStatus.FULFILLED
        : PurchaseOrderItemStatus.PARTIAL;
}
/**
 * Computes expected PO header status from current line balances.
 *
 * Caller contract: do not write `ISSUED` onto a PO whose DB status is already
 * `SHIPPED` — keep `SHIPPED` when this helper returns `ISSUED` (stateless helper
 * cannot see prior header state).
 */
export function purchaseOrderStatusAfterReceive(lines) {
    if (lines.length === 0) {
        return PurchaseOrderStatus.ISSUED;
    }
    const allFulfilled = lines.every((line) => line.qtyToFulfill > 0 && roundQty(line.qtyFulfilled) >= roundQty(line.qtyToFulfill));
    if (allFulfilled) {
        return PurchaseOrderStatus.RECEIVED;
    }
    const anyProgress = lines.some((line) => roundQty(line.qtyFulfilled) > 0);
    if (anyProgress) {
        return PurchaseOrderStatus.PARTIALLY_RECEIVED;
    }
    return PurchaseOrderStatus.ISSUED;
}
//# sourceMappingURL=rules.js.map